import React, { useRef, useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form } from '@unform/web';
import { FiMail, FiLogIn } from 'react-icons/fi';
import * as Yup from 'yup';

import loadingGif from '~/assets/img/loadingMusic.gif';
import { useToast } from '~/hooks/toast';
import getValidationErrors from '~/utils/getValidationErrors';
import Input from '~/components/Input';
import Button from '~/components/Button';
import * as S from './styles';
import { useForgotPasswordEmailMutation } from 'src/graphql/generated/graphql';

export default function SignIn() {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [disable, setDisable] = useState('');
  const [loading, setLoading] = useState(false);

  const [forgotPasswordEmail] = useForgotPasswordEmailMutation();

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Insira um e-mail válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setDisable(disable === '' ? 'active' : '');

        setLoading(true);

        data.goTo = `${process.env.REACT_APP_URL}/alterar-senha`;

        const response = await forgotPasswordEmail({
          variables: {
            data: {
              email: data.email,
            },
          },
        });

        const { title, message } = response.data?.forgotPasswordEmail;

        setLoading(false);

        navigate(`/email-enviado/${title}/${message}`);
      } catch (error) {
        setLoading(false);
        setDisable(disable === 'active' ? '' : '');

        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current.setErrors(errors);

          return;
        }

        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          addToast({
            type: 'error',
            title: 'Erro na recuperação de senha',
            description: error.graphQLErrors[0].message,
          });
          return;
        }

        if (error.networkError) {
          addToast({
            type: 'error',
            title: 'Erro na conexão',
            description:
              'Serviço de dados indisponível no momento, favor tente mais tarde!',
          });
          return;
        }
      }
    },
    [addToast, navigate, disable, forgotPasswordEmail]
  );

  return (
    <S.BackgroundSectionForgotPass>
      <S.DivRightLogin>
        <h1>Recuperar senha</h1>
        <p>Digite seu endereço de e-mail para redefinir a senha.</p>
        <p>
          Talvez você precise verificar sua pasta de spams ou desbloquear o
          e-mail no-reply@acordeon.com.br.
        </p>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Input icon={FiMail} name="email" type="email" placeholder="E-mail" />

          <Button type="submit" disabled={loading} className={disable}>
            Enviar
          </Button>
          {loading && <img src={loadingGif} alt="Carregando..." width="50px" />}
        </Form>

        <Link to="/login">
          <FiLogIn /> Voltar para o login
        </Link>
      </S.DivRightLogin>
    </S.BackgroundSectionForgotPass>
  );
}
